import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../Firestore/FirestoreConfig";

export const RC_WEB_INVITATION_MAPPING_HARDENING =
  "web_invitation_mapping_hardening";

const DEFAULT_INVITATION_MAPPING_HARDENING_ENABLED = true;
const DEFAULT_REFRESH_MIN_INTERVAL_MS = 30 * 1000;

let invitationMappingHardeningEnabled =
  DEFAULT_INVITATION_MAPPING_HARDENING_ENABLED;
let refreshInFlightPromise = null;
let lastRefreshAtMs = 0;

const readInvitationMappingHardeningValue = () => {
  if (!remoteConfig) {
    return DEFAULT_INVITATION_MAPPING_HARDENING_ENABLED;
  }

  try {
    return getValue(
      remoteConfig,
      RC_WEB_INVITATION_MAPPING_HARDENING
    ).asBoolean();
  } catch (_error) {
    return DEFAULT_INVITATION_MAPPING_HARDENING_ENABLED;
  }
};

invitationMappingHardeningEnabled = readInvitationMappingHardeningValue();

export const isInvitationMappingHardeningEnabled = () =>
  invitationMappingHardeningEnabled;

export const refreshInvitationMappingHardeningFlag = async ({
  force = false,
  minIntervalMs = DEFAULT_REFRESH_MIN_INTERVAL_MS,
} = {}) => {
  if (!remoteConfig) {
    invitationMappingHardeningEnabled =
      DEFAULT_INVITATION_MAPPING_HARDENING_ENABLED;
    return invitationMappingHardeningEnabled;
  }

  const now = Date.now();
  if (!force && now - lastRefreshAtMs < minIntervalMs) {
    return invitationMappingHardeningEnabled;
  }

  if (refreshInFlightPromise) {
    return refreshInFlightPromise;
  }

  refreshInFlightPromise = (async () => {
    try {
      await fetchAndActivate(remoteConfig);
    } catch (_error) {
      // Preserve cached/default value when fetch fails.
    }

    invitationMappingHardeningEnabled = readInvitationMappingHardeningValue();
    lastRefreshAtMs = Date.now();
    return invitationMappingHardeningEnabled;
  })();

  try {
    return await refreshInFlightPromise;
  } finally {
    refreshInFlightPromise = null;
  }
};
